import { Collapse } from "antd";
import styled from "styled-components";

export const StyledPromoCollapse = styled(Collapse)`
    width: 100%;
    border: none;
    border-radius: 0;

    .ant-collapse-content-box {
        padding: 8px;
    }
`;

export const StyledAccordionHeader = styled.div<{
    isZeroPresents: boolean;
    isExternal: boolean;
}>`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;

    &::before {
        display: ${(props) =>
            props.isZeroPresents || props.isExternal ? "block" : "none"};
        content: "";
        position: absolute;
        top: 0;
        left: -48px;
        width: 5px;
        height: 100%;
        background-color: ${(props) =>
            props.isZeroPresents
                ? "#f16a1b"
                : props.isExternal
                  ? "#1677ff"
                  : "transparent"};
    }
`;
